import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { NodeId } from '@/lib/litegraph/src/LGraphNode'

/**
 * 부모 윈도우(nordy-app)에서 postMessage로 전달받은
 * 워크플로우 API 입력/출력 하이라이트 상태를 관리하는 스토어
 */
export const useWorkflowApiHighlightStore = defineStore(
  'workflowApiHighlight',
  () => {
    const highlightedInputs = ref<[NodeId, string][]>([])
    const highlightedOutputs = ref<NodeId[]>([])

    /** 현재 마우스가 호버 중인 위젯 — [nodeId, widgetName] */
    const hoveredWidget = ref<[NodeId, string] | null>(null)

    function setHighlights(inputs: [NodeId, string][], outputs: NodeId[]) {
      highlightedInputs.value = inputs
      highlightedOutputs.value = outputs
    }

    function clearHighlights() {
      highlightedInputs.value = []
      highlightedOutputs.value = []
    }

    return {
      highlightedInputs,
      highlightedOutputs,
      hoveredWidget,
      setHighlights,
      clearHighlights
    }
  }
)
